import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

interface ClosedGamesHintProps {
  onShowClosedGames: () => void;
  shouldShowHint: boolean;
}

export default function ClosedGamesHint({
  shouldShowHint,
  onShowClosedGames,
}: ClosedGamesHintProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (shouldShowHint) {
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else {
      setIsVisible(false);
    }
  }, [shouldShowHint]);

  if (!shouldShowHint) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed right-2.5 bottom-20 left-2.5 z-40 flex items-center justify-between gap-3 rounded-lg bg-rich-black/90 px-4 py-3 shadow-0-0-4 shadow-black/60 backdrop-blur-md transition-opacity md:right-auto md:bottom-6 md:left-1/2 md:w-1/3 md:-translate-x-1/2",
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      )}
    >
      <p className="text-14 text-white/90">
        Don&apos;t see what you are looking for?
      </p>
      <button
        className="shrink-0 cursor-pointer rounded-lg bg-white px-4 py-1.5 font-bold text-13 text-black"
        onClick={onShowClosedGames}
        type="button"
      >
        Show closed experiences
      </button>
    </div>
  );
}
